<template>
  <span class="observer">
    <i class="observer-top" />
    <i class="observer-bottom" />
  </span>
</template>

<script>
import 'intersection-observer'

export default {
  data () {
    return {
      ioTop: null,
      ioBottom: null
    }
  },
  mounted () {
    this.setObserver()
  },
  beforeDestroy () {
    if (this.ioTop) {
      this.ioTop.disconnect()
      this.ioTop = null
    }

    if (this.ioBottom) {
      this.ioBottom.disconnect()
      this.ioBottom = null
    }
  },
  methods: {
    onObserver (entries, observer) {
      entries.forEach(entry => {
        // 가시성의 변화가 있으면 관찰 대상 전체에 대한 콜백이 실행되므로,
        // 관찰 대상의 교차 상태가 false일(보이지 않는) 경우 실행하지 않음.
        if (!entry.isIntersecting) {
          return
        }
        // 관찰 대상의 교차 상태가 true일(보이는) 경우 실행.
        console.log(entry.target) // entry is 'IntersectionObserverEntry'

        // 위 실행을 처리하고(1회) 관찰 중지
        // observer.unobserve(entry.target)
      })
    },
    setObserver () {
      // 참고
      // https://heropy.blog/2019/10/27/intersection-observer/
      // disconnect

      // console.log('----------------', document.querySelectorAll('.observer-top'))
      this.ioTop = new IntersectionObserver(this.onObserver, {
        // rootMargin: '-122px 0px 0px 0px'
      })

      this.ioBottom = new IntersectionObserver(this.onObserver, {
        // rootMargin: '-72px 0px 0px 0px'
      })

      this.ioTop.observe(this.$el.querySelector('.observer-top'))
      this.ioBottom.observe(this.$el.querySelector('.observer-bottom'))
    }
  }
}
</script>
